// extracted by mini-css-extract-plugin
export default {"fup-text":"ExpandableFupText_fup-text__LpfFa","fup-text-expanded":"ExpandableFupText_fup-text-expanded__G+Lpu","expandable-fup-text":"ExpandableFupText_expandable-fup-text__mw1VF"};